import {
  FETCH_BOOKEDSERVICES_SUCCESS,
  FETCH_BOOKEDSERVICES_FAILURE,
} from "../actionTypes";

const initialState = {
  bookedservices: [],
  error: null,
  message: null,
};

export const bookedServicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BOOKEDSERVICES_SUCCESS:
      return {
         ...state,
        bookedservices: action.payload.bookedservices,
        message: action.payload.message, 
     };

    case FETCH_BOOKEDSERVICES_FAILURE:
      return { 
        ...state,
        error: action.payload,
        message:null,
    };

    default:
      return state;
  }
};
